import React from "react";
import {
  NavbarSkeletonContainer,
  NavbarTabSkeleton,
  CardGridSkeleton,
  CardSkeletonContainer,
  StatusSkeleton,
  ImageSkeleton,
  SkuSkeleton,
  TitleSkeleton,
  PriceSkeleton,
  FooterSkeletonRow,
  QuantitySkeleton,
  AddButtonSkeleton,
} from "./Skeleton.styles";

export const CatalogueNavbarSkeleton = () => {
  return (
    <NavbarSkeletonContainer>
      {Array.from({ length: 8 }).map((_, idx) => (
        <NavbarTabSkeleton key={idx} />
      ))}
    </NavbarSkeletonContainer>
  );
};

export const ProductCardSkeleton = () => {
  return (
    <CardSkeletonContainer>
      <StatusSkeleton />
      <ImageSkeleton />
      <SkuSkeleton />
      <TitleSkeleton />
      <TitleSkeleton style={{ width: "70%" }} />
      <PriceSkeleton />
      <FooterSkeletonRow>
        <QuantitySkeleton />
        <AddButtonSkeleton />
      </FooterSkeletonRow>
    </CardSkeletonContainer>
  );
};

export const CatalogueGridSkeleton = ({ cardsCount = 8 }) => {
  return (
    <CardGridSkeleton>
      {Array.from({ length: cardsCount }).map((_, idx) => (
        <ProductCardSkeleton key={idx} />
      ))}
    </CardGridSkeleton>
  );
};
